import { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormCardLayout } from '@main/components';
import Button from '@mui/material/Button';
import { showMessage } from 'app/store/core/messageSlice';
import { useRequest } from '@main/hooks';
import { useSimpleAlert } from '@main/hooks/useSimpleAlert';
import {
  faceprintServerInstall,
  fingerprintServerInstall,
  managerInstall,
  notifyInstall,
  terminalsInstall,
} from 'src/app/api/setup';
import { delayFunction } from 'src/app/utils/timer';
import { arraysContainSameValues } from 'src/app/utils/conversors';
import { Divider } from '@mui/material';
import { checkpointsServices, getCompletedCheckpoints } from '../Checkpoints/checkpoints';
import { ProgressStep } from '../Components';
import { StepperContext } from '../Context/SetupContext';

export const Services = ({ onSuccess = () => {} }) => {
  const Dispatch = useDispatch();
  const openAlert = useSimpleAlert();
  const { addLogs, companyId, currentCheckpoint, repoGlobalOptions } = useContext(StepperContext);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [versionTagsList, setVersionTagsList] = useState([]);
  const [levelTagsList, setLevelTagsList] = useState([]);
  const [disableButton, setDisableButton] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  // -------- Obteniendo checkpoints
  const handleUpdateSteps = (incomingStep) => {
    const stepIsThere = completedSteps.includes(incomingStep);
    if (stepIsThere) return;
    setCompletedSteps((current) => [...current, incomingStep]);
  };

  useEffect(() => {
    if (currentCheckpoint === undefined || currentCheckpoint === null) return;
    const isThere = checkpointsServices.includes(currentCheckpoint);
    if (!isThere) return;
    console.log(currentCheckpoint);
    const checkpointsList = getCompletedCheckpoints(currentCheckpoint);
    if (checkpointsList !== undefined) {
      console.log(checkpointsList);
      setCompletedSteps(checkpointsList);
    }
  }, [currentCheckpoint]);

  useEffect(() => {
    console.log('completed steps', completedSteps);
    if (completedSteps === undefined) return;
    console.log('has changed completedSteps');
    const isStepsComplete = arraysContainSameValues(completedSteps, checkpointsServices);
    console.log('Esta completo? ', isStepsComplete);
    setIsCompleted(isStepsComplete);
  }, [completedSteps]);

  useEffect(() => {
    if (isCompleted === undefined) return;
    onSuccess(isCompleted);
  }, [isCompleted]);

  // -------- Definicion de requests
  const {
    makeRequest: tryNotifyInstall,
    isLoading: isLoadingNotifyInstall,
    status: statusNotifyInstall,
    logger: loggerNotifyInstall,
  } = useRequest(notifyInstall);

  const {
    makeRequest: tryTerminalsInstall,
    isLoading: isLoadingTerminalsInstall,
    status: statusTerminalsInstall,
    logger: loggerTerminalsInstall,
  } = useRequest(terminalsInstall);

  const {
    makeRequest: tryManagerInstall,
    isLoading: isLoadingManagerInstall,
    status: statusManagerInstall,
    logger: loggerManagerInstall,
  } = useRequest(managerInstall);

  const {
    makeRequest: tryFaceprintServerInstall,
    isLoading: isLoadingFaceprintServerInstall,
    status: statusFaceprintServerInstall,
    logger: loggerFaceprintServerInstall,
  } = useRequest(faceprintServerInstall);

  const {
    makeRequest: tryFingerprintServerInstall,
    isLoading: isLoadingFingerprintServerInstall,
    status: statusFingerprintServerInstall,
    logger: loggerFingerprintServerInstall,
  } = useRequest(fingerprintServerInstall);

  // -------- Loggers
  useEffect(() => {
    if (loggerNotifyInstall === undefined) return;
    addLogs(loggerNotifyInstall);
  }, [loggerNotifyInstall]);

  useEffect(() => {
    if (loggerTerminalsInstall === undefined) return;
    addLogs(loggerTerminalsInstall);
  }, [loggerTerminalsInstall]);

  useEffect(() => {
    if (loggerManagerInstall === undefined) return;
    addLogs(loggerManagerInstall);
  }, [loggerManagerInstall]);

  useEffect(() => {
    if (loggerFaceprintServerInstall === undefined) return;
    addLogs(loggerFaceprintServerInstall);
  }, [loggerFaceprintServerInstall]);

  useEffect(() => {
    if (loggerFingerprintServerInstall === undefined) return;
    addLogs(loggerFingerprintServerInstall);
  }, [loggerFingerprintServerInstall]);

  const tryStepsWizard = async () => {
    setDisableButton(true);
    if (companyId === undefined) {
      Dispatch(
        showMessage({
          message: 'No se encontro el ID de compania',
        })
      );
      setDisableButton(false);
      return;
    }
    try {
      // ---- Instalar Notify
      const step11ok = await delayFunction(
        completedSteps.includes(checkpointsServices[0]),
        tryNotifyInstall,
        companyId
      );
      if (!step11ok) return;
      handleUpdateSteps(checkpointsServices[0]);
      console.log('Step okii');

      // ---- Instalar Terminals
      const step12ok = await delayFunction(
        completedSteps.includes(checkpointsServices[1]),
        tryTerminalsInstall,
        companyId
      );
      if (!step12ok) return;
      handleUpdateSteps(checkpointsServices[1]);
      console.log('Step okii');

      // ---- Instalar Manager
      const step13ok = await delayFunction(
        completedSteps.includes(checkpointsServices[2]),
        tryManagerInstall,
        companyId
      );
      if (!step13ok) return;
      handleUpdateSteps(checkpointsServices[2]);
      console.log('Step okii');

      // ---- Instalar Faceprint Server
      const step14ok = await delayFunction(
        completedSteps.includes(checkpointsServices[3]),
        tryFaceprintServerInstall,
        companyId
      );
      if (!step14ok) return;
      handleUpdateSteps(checkpointsServices[3]);
      console.log('Step okii');

      // ---- Instalar Fingerprint Server
      const step15ok = await delayFunction(
        completedSteps.includes(checkpointsServices[4]),
        tryFingerprintServerInstall,
        companyId
      );
      if (!step15ok) return;
      handleUpdateSteps(checkpointsServices[4]);
      console.log('Step okii');
    } catch (error) {
      console.log(error);
    } finally {
      setDisableButton(false);
    }
  };

  const handleBypassStep = (stepName) => {
    if (typeof stepName !== 'string' || stepName === undefined) return;
    openAlert({
      title: 'Atencion',
      description: 'Esta seguro que desea omitir este paso?',
    }).then((userResponseOk) => {
      if (!userResponseOk) return;
      handleUpdateSteps(stepName);
      Dispatch(
        showMessage({
          message: `El paso ${stepName} ha sido omitido`,
        })
      );
    });
  };

  const handleManualRetry = (reqToRetry = () => new Promise(), ...args) => {
    reqToRetry(...args)
      .then((isOk) => {
        console.log(isOk);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <FormCardLayout.FullColum>
        <div className="mt-24 flex flex-row w-full justify-center items-center">
          <Button
            aria-label="Comenzar"
            onClick={() => tryStepsWizard()}
            variant="contained"
            className="w-full md:w-auto"
            color="primary"
            disabled={disableButton || isCompleted}
          >
            Comenzar
          </Button>
        </div>
      </FormCardLayout.FullColum>
      <FormCardLayout.FullColum>
        <Divider variant="middle" />
      </FormCardLayout.FullColum>
      <FormCardLayout.FullColum>
        <div className="px-32 flex flex-col w-full justify-start items-start">
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsServices[0])}
            status={
              completedSteps.includes(checkpointsServices[0]) ? 'SUCCESS' : statusNotifyInstall
            }
            isLoading={isLoadingNotifyInstall}
            stepName="Instalando Notify"
            disableOptions={completedSteps.includes(checkpointsServices[0])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsServices[1])}
            status={
              completedSteps.includes(checkpointsServices[1]) ? 'SUCCESS' : statusTerminalsInstall
            }
            isLoading={isLoadingTerminalsInstall}
            stepName="Instalando Terminals"
            disableOptions={completedSteps.includes(checkpointsServices[1])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsServices[2])}
            status={
              completedSteps.includes(checkpointsServices[2]) ? 'SUCCESS' : statusManagerInstall
            }
            isLoading={isLoadingManagerInstall}
            stepName="Instalando Manager"
            disableOptions={completedSteps.includes(checkpointsServices[2])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsServices[3])}
            status={
              completedSteps.includes(checkpointsServices[3])
                ? 'SUCCESS'
                : statusFaceprintServerInstall
            }
            isLoading={isLoadingFaceprintServerInstall}
            stepName="Instalando Faceprint Server"
            disableOptions={completedSteps.includes(checkpointsServices[3])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsServices[4])}
            status={
              completedSteps.includes(checkpointsServices[4])
                ? 'SUCCESS'
                : statusFingerprintServerInstall
            }
            isLoading={isLoadingFingerprintServerInstall}
            stepName="Instalando Fingerprint Server"
            disableOptions={completedSteps.includes(checkpointsServices[4])}
          />
        </div>
      </FormCardLayout.FullColum>
    </>
  );
};
